.card {
  cursor: pointer;
  overflow: hidden;
  border-radius: 8px;
}

.image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s;
}

.image:hover {
  transform: scale(1.05);
}